import React from 'react';
import RecipeCarousel from '../components/RecipeCarousel';
import styles from '../styles/About.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const recipes = [
  {
    id: 'bloody-mary',
    title: 'Bloody Mary',
    subtitle: 'Bright, savoury, and fresh',
    image: `${publicUrl}/images/gallery/gallery5.webp`,
    alt: 'Fresh drinks at Grain Bites',
    action: 'View the bar menu',
    to: `${publicUrl}/Bar`,
  },
  {
    id: 'margarita',
    title: 'Margarita',
    subtitle: 'A bright citrus classic',
    image: `${publicUrl}/images/gallery/gallery7.webp`,
    alt: 'A colorful drink at Grain Bites',
    action: 'View the bar menu',
    to: `${publicUrl}/Bar`,
  },
  {
    id: 'blue-lagoon',
    title: 'Blue Lagoon',
    subtitle: 'Cool colour, easy mood',
    image: `${publicUrl}/images/gallery/gallery2.webp`,
    alt: 'A prepared dish at Grain Bites',
    action: 'View the bar menu',
    to: `${publicUrl}/Bar`,
  },
  {
    id: 'zombie',
    title: 'Zombie',
    subtitle: 'A generous tropical pour',
    image: `${publicUrl}/images/gallery/gallery3.webp`,
    alt: 'Food and drinks prepared for guests',
    action: 'View the bar menu',
    to: `${publicUrl}/Bar`,
  },
  {
    id: 'fresh-bread',
    title: 'Fresh bread',
    subtitle: 'Slow baked for sharing',
    image: `${publicUrl}/images/breads/dinkel-bread1.webp`,
    alt: 'Fresh homemade artisan bread',
    action: 'Explore artisan breads',
    to: `${publicUrl}/Artisan-Breads`,
  },
];

const stories = [
  {
    title: 'Little history of Grain Bites',
    text: 'Grain Bites ist ein 2016 gegründetes und im kreativen Zentrum Berlins beheimatetes Catering- und Eventunternehmen. Als Köche, Eventcaterer, Barkeeper, Sommeliers und Designer haben wir uns zusammengefunden, um im engen Austausch der Disziplinen neuen Ideen nachzugehen.',
    image: '/images/brand/the_place1.webp',
    imageAlt: 'The Grain Bites space',
  },
  {
    title: 'A place for every occasion',
    text: 'Vogel versprüht den typischen Charme der Hauptstadt und eignet sich hervorragend für Weihnachtsfeiern, Teamevents, private Feiern, Dinner-Events, Workshops, Firmenevents sowie Foto- und Filmevents. Durch den großzügigen Außenbereich werden auch Sommerfeste zu besonderen Erlebnissen.',
    image: '/images/brand/bar1.webp',
    imageAlt: 'The bar atmosphere',
    reverse: true,
  },
  {
    title: 'Food catering and more',
    text: 'Wir bieten maßgeschneiderte kulinarische Umsetzungen an und schöpfen dabei aus einem großen Erfahrungsschatz im Eventcatering. Vom Fotoshooting über Messecatering und Streetfood-Markt bis zum Hochzeitlichen Galadinner: Wir entwickeln individuelle gastronomische Konzepte mit Offenheit und Austausch.',
    image: '/images/brand/catering.webp',
    imageAlt: 'Catering table',
  },
  {
    title: 'Made fresh for your guests',
    text: 'Die Gerichte werden nach Ihrem Geschmack zusammengestellt und vor Ort frisch zubereitet. Neben dem Buffet kann auch eine Kochstation integriert werden. Herzhaftes und süße Konditorware werden sorgfältig dekoriert und serviert, denn das Auge isst bekanntlich mit.',
    image: '/images/brand/the_place.webp',
    imageAlt: 'Freshly prepared food',
    reverse: true,
  },
];

const About = () => (
  <main className={styles.page} id="our-story">
    <header
      className={styles.hero}
      style={{ backgroundImage: `url(${publicUrl}/images/hero/artisan-bread-bg.webp)` }}
    >
      <p className={styles.eyebrow}>Grain Bites</p>
      <h1>Our story</h1>
      <p>Food, drinks, and thoughtful events made in the spirit of Kreuzberg.</p>
    </header>

    <div className={styles.storyList}>
      {stories.map(story => (
        <article
          className={`${styles.story} ${story.reverse ? styles.reverse : ''}`}
          key={story.title}
        >
          <div className={styles.storyCopy}>
            <p className={styles.sectionLabel}>The Grain Bites way</p>
            <h2>{story.title}</h2>
            <p>{story.text}</p>
          </div>
          <div className={styles.storyImage}>
            <img
              src={`${publicUrl}${story.image}`}
              alt={story.imageAlt}
              loading="lazy"
              decoding="async"
            />
          </div>
        </article>
      ))}
    </div>

    <RecipeCarousel
      eyebrow="Chef's pick"
      title="Grain Bites creations"
      items={recipes}
      ariaLabel="Grain Bites food and drink creations"
    />

    <section
      className={styles.crew}
      style={{ backgroundImage: `url(${publicUrl}/images/grain-bitess.webp)` }}
    >
      <div className={styles.crewOverlay}>
        <p className={styles.sectionLabel}>The people behind it</p>
        <h2>The Crew</h2>
        <p>
          Ein Team aus Köchen, Barkeepern, Sommeliers und Designern. Gemeinsam
          entwickeln wir neue Ideen für besondere Tische und Veranstaltungen.
        </p>
      </div>
    </section>
  </main>
);

export default About;
